import type { ReactElement } from 'react';
import { useDocumentTitle } from '../useDocumentTitle';

/** Where a person lands after deleting their account: signed out, so public and shell-less. */
export function AccountDeletedRoute({ graceDays }: { graceDays: number | null }): ReactElement {
  useDocumentTitle('Account scheduled for deletion');
  const days = graceDays ?? 7;
  return (
    <main className="min-h-screen grid place-items-center p-6 bg-surface text-ink font-ui">
      <div className="max-w-md flex flex-col gap-2">
        <h1 className="m-0 p-0 text-2xl font-semibold text-ink">Your account is scheduled for deletion</h1>
        <p className="m-0 p-0 text-md text-muted">
          Your data is removed within {days} days. A pseudonymised activity log and a record that the deletion happened
          are kept, without your name or email. If this was a mistake, email support before then.
        </p>
      </div>
    </main>
  );
}
